<div class="flex items-center justify-center mb-3">
  @if (visibleIncrementDecrement()) {
    <button
      type="button"
      id="soft-test-decrement-btn"
      class="w-14! soft-button bg-gray-400 text-white font-semibold! rounded! rounded-r-none!"
      [ngClass]="disabled() ? '' : 'hover:bg-gray-600'"
      [disabled]="disabled()"
      (click)="decrement()"
      [style]="{ height: height() }"
    >
      -
    </button>
  }

  <div
    class="w-full flex items-center justify-between gap-2 px-3 bg-surface border border-gray-400"
    [ngClass]="visibleIncrementDecrement() ? 'border-r-0 border-l-0' : 'rounded'"
    [style]="{ height: height() }"
  >
    @if (!isOnlyPositive()) {
      <button
        type="button"
        id="soft-test-sign-btn"
        class="soft-button bg-surface p-3 font-semibold rounded"
        [ngClass]="disabled() ? '' : 'hover:bg-hover'"
        [disabled]="disabled()"
        (click)="convertPositiveNegative()"
      >
        <p>+/-</p>
      </button>
    }

    <div class="w-full flex items-center justify-end gap-2">
      @let value = stringValue().replace('.', ',');
      <input
        #valueElement
        inputmode="none"
        class="appearance-none text-lg w-full font-semibold text-right"
        [ngClass]="disabled() ? 'opacity-50' : ''"
        [disabled]="disabled()"
        [value]="(value | isDefinedNotEmpty) ? value : '0'"
        (input)="onNumKeyboardInput($event)"
        (keydown)="onEnterKey($event)"
        (keydown.space)="preventSpace($event)"
      />
    </div>
  </div>

  @if (visibleIncrementDecrement()) {
    <button
      type="button"
      id="soft-test-increment-btn"
      class="w-14! soft-button bg-gray-400 text-white font-semibold! rounded! rounded-l-none!"
      [ngClass]="disabled() ? '' : 'hover:bg-gray-600'"
      [disabled]="disabled()"
      (click)="increment()"
      [style]="{ height: height() }"
    >
      <soft-ds-icon name="fa-regular fa-plus" />
    </button>
  }
</div>

@if (quickNumbers() | isDefinedNotEmpty) {
  <div
    class="flex items-center gap-2 whitespace-nowrap overflow-y-hidden overflow-x-auto mb-3 w-full"
  >
    @for (num of quickNumbers(); track num) {
      <button
        type="button"
        id="soft-test-quick-number-btn"
        class="py-1 px-2 soft-button-secondary font-semibold rounded flex-auto"
        [ngClass]="disabled() ? '' : 'hover:bg-hover'"
        [disabled]="disabled()"
        (click)="chooseQuickNumber(num)"
        [style]="{ height: height() }"
      >
        {{ num.toString().replace('.', ',') }}
      </button>
    }
  </div>
}

<div class="flex w-full gap-2">
  <div class="grid grid-cols-3 w-[75%] gap-2">
    @for (num of givenNumbers; track num) {
      <button
        type="button"
        id="soft-test-append-number-btn"
        class="border border-gray-300 py-2 font-semibold text-lg rounded bg-surface"
        [ngClass]="disabled() ? 'opacity-50' : 'hover:bg-hover'"
        [disabled]="disabled()"
        [style]="{ height: height() }"
        (click)="appendNumber(num)"
      >
        {{ num }}
      </button>
    }
    <button
      type="button"
      id="soft-test-append-zero-btn"
      class="border border-gray-300 py-2 font-semibold text-lg rounded bg-surface"
      [ngClass]="disabled() ? 'opacity-50' : 'hover:bg-hover'"
      [disabled]="disabled()"
      [style]="{ height: height() }"
      (click)="appendNumber(0)"
    >
      0
    </button>
    <button
      type="button"
      id="soft-test-append-double-zero-btn"
      class="border border-gray-300 py-2 font-semibold rounded bg-surface"
      [ngClass]="disabled() ? 'opacity-50' : 'hover:bg-hover'"
      [disabled]="disabled()"
      [style]="{ height: height() }"
      (click)="appendZeroZero()"
    >
      <p>00</p>
    </button>
    <button
      type="button"
      id="soft-test-append-comma-btn"
      class="soft-button bg-gray-400 py-2 rounded"
      [ngClass]="disabled() ? '' : 'hover:bg-gray-600'"
      [disabled]="disabled()"
      [style]="{ height: height() }"
      (click)="appendComma()"
    >
      <i class="fa-regular fa-comma text-white font-semibold"></i>
    </button>
  </div>

  <div class="grid grid-rows-4 w-[25%] gap-2">
    <button
      type="button"
      id="soft-test-clear-btn"
      class="border border-red-400 flex items-center justify-center rounded bg-surface"
      [ngClass]="disabled() ? 'opacity-50' : 'hover:bg-hover'"
      [disabled]="disabled()"
      [style]="{ height: height() }"
      (click)="clear()"
    >
      <i class="fa-regular fa-a text-red-500 font-semibold mr-0.5"></i>
      <i class="fa-regular fa-c text-red-500 font-semibold"></i>
    </button>
    <button
      type="button"
      id="soft-test-back-space-btn"
      class="soft-button bg-danger-600 rounded"
      [ngClass]="disabled() ? '' : 'hover:bg-danger-800'"
      [disabled]="disabled()"
      [style]="{ height: height() }"
      (click)="backspace()"
    >
      <i class="fa-regular fa-delete-left text-white font-semibold"></i>
    </button>
    @if (visibleEnter()) {
      <button
        type="button"
        id="soft-test-save-btn"
        [disabled]="!canSubmit() || disabled()"
        [ngClass]="disabled() ? '' : 'hover:bg-green-800'"
        class="soft-button row-span-2 rounded bg-green-500"
        (click)="onSave()"
      >
        <i class="fa-regular fa-arrow-turn-down-left text-white font-semibold"></i>
      </button>
    }
  </div>
</div>
